import axios from "axios";
import config from "../config/config";
import { utils } from "../utils/utils";

export const handleError = (err) => {
  if (err?.response?.status === 401) {
    window.location.href = `/auth/sign-in?returnURL=${window.location.pathname}`;
  } else if (err?.response?.status === 404) {
    window.location.href = "/error/404";
  } else if (err?.response?.status === 400 || err?.response?.status === 422) {
    throw err;
  } else {
    window.location.href = "/error/500";
  }
};

export const craneInspectionsApi = {
  getCraneInspectionsByTripId: (data) => {
    const query = utils.buildQueryString(data);
    return axios(`/api/crane-inspections?${query}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      headers: { "web-version": process.env.REACT_APP_VERSION },
      method: "get",
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  getCraneInspectionSections: () => {
    return axios(`/api/crane-inspection-sections`, {
      baseURL: config.apiURL,
      withCredentials: true,
      headers: { "web-version": process.env.REACT_APP_VERSION },
      method: "get",
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  getCraneInspectionDestinations: (craneInspectionId) => {
    return axios(
      `/api/crane-inspections/work-order-destinations?craneInspectionId=${craneInspectionId}`,
      {
        baseURL: config.apiURL,
        withCredentials: true,
        headers: { "web-version": process.env.REACT_APP_VERSION },
        method: "get",
      }
    )
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  moveCraneInspection: (data) => {
    return axios(`/api/crane-inspections/move/${data.id}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      headers: { "web-version": process.env.REACT_APP_VERSION },
      method: "patch",
      data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
};
